import { EmptyArray } from 'lib/array/arrayUtils'
import { floatify } from 'lib/maths/mathUtils'
import { createSelector } from 'reselect'
import getCheckoutLoyaltyPointBurnCalculationView from './getCheckoutLoyaltyPointBurnCalculationView'

const getCheckoutLoyaltyBurningPointItems = createSelector(
  (state: App.State) => state.checkout.loyalty.pointsToBurn,
  (state: App.State) => getCheckoutLoyaltyPointBurnCalculationView(state),
  (
    pointsToBurn,
    pointBurnCalculationView,
  ): Array<App.Checkout.LoyaltyBurningPointItem> => {
    if (!pointsToBurn) return EmptyArray
    if (!pointBurnCalculationView.data) return EmptyArray
    if (pointBurnCalculationView.data.minBurnablePoints > pointsToBurn) return EmptyArray
    if (pointBurnCalculationView.data.burnableItems.length === 0) return EmptyArray

    const pointsToBurnPerItem: Array<App.Checkout.LoyaltyBurningPointItem> = []
    let remainingPoints = pointsToBurn
    for (const pointBurnViewItem of pointBurnCalculationView.data.burnableItems) {
      if (remainingPoints <= 0) break
      const pointsPaid = Math.min(pointBurnViewItem.payablePriceInPoints, remainingPoints)
      const priceInPoints = pointBurnViewItem.actualPriceInPoints
      const priceInCurrency = pointBurnViewItem.actualPriceInCurrency
      const pointsPaidInCurrency = floatify((pointsPaid * priceInCurrency) / priceInPoints)

      // Get orderItemId for post-purchase flows (e.g., BNBL select-date)
      const orderItemId = 'orderItemId' in pointBurnViewItem.itemView.item
        ? pointBurnViewItem.itemView.item.orderItemId
        : undefined

      pointsToBurnPerItem.push({
        priceInCurrency,
        priceInPoints,
        pointsPaid,
        pointsPaidInCurrency,
        mx: pointBurnViewItem.itemView.mx,
        productType: pointBurnViewItem.itemView.loyalty.productType!,
        itemTransactionKey: pointBurnViewItem.itemView.item.transactionKey,
        itemId: pointBurnViewItem.itemView.item.itemId,
        orderItemId,
      })
      remainingPoints -= pointsPaid
    }

    if (!pointsToBurnPerItem.length) return EmptyArray

    return pointsToBurnPerItem
  },
)

export default getCheckoutLoyaltyBurningPointItems
